import api from "../../utils/Api";
import {
  SWITCH_ROLES_REQUEST,
  SWITCH_ROLES_SUCCESS,
  SWITCH_ROLES_ERROR,
} from "./SwitchRolesTypes";

export const switchRolesRequest = () => {
  return {
    type: SWITCH_ROLES_REQUEST,
  };
};

export const switchRolesSuccess = (switchRoles) => {
  return {
    type: SWITCH_ROLES_SUCCESS,
    payload: switchRoles,
  };
};

export const switchRolesFailure = (error) => {
  return {
    type: SWITCH_ROLES_ERROR,
    payload: error,
  };
};

export const switchRoles = (role_id) => {

    const headers = {
        'Content-Type': 'application/json',
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        let user_id = localStorage.getItem("USER_INFO") && 
        JSON.parse(localStorage.getItem("USER_INFO")).user_id;

        const payload = {
            role_id: role_id,
            user_id: user_id
        }
  return async (dispatch) => {
    dispatch(switchRolesRequest());
    try {
        const response = await api.post("user/switchRole", payload, {
            headers: headers,
          });
      const switchRolesData = response.data.data;
      dispatch(switchRolesSuccess(switchRolesData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(switchRolesFailure(errorMsg));
    }
  };
};
